import { IamErrorConfig, PKG_NAME } from '@services/store';

export const CLEAR_ALL_STATE = `${PKG_NAME}/CLEAR_ALL_STATE`;
export const SET_ERROR_CONFIG = `${PKG_NAME}/SET_ERROR_CONFIG`;

export const clearAllState = () => ({
  type: CLEAR_ALL_STATE,
});

export const setErrorConfig = (payload: IamErrorConfig) => ({
  type: SET_ERROR_CONFIG,
  payload: payload,
});
